<template>
  <v-card outlined rounded="xl" class="rh-etapa-nav">
    <v-card-text v-if="mobile" class="d-flex align-center pa-2">
      <v-btn
        icon
        large
        aria-label="Etapa anterior"
        :disabled="submitting || etapaAtual === 1"
        @click="$emit('voltar')"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-btn
        icon
        large
        color="primary"
        class="mr-2"
        aria-label="Salvar alterações"
        :loading="submitting"
        :disabled="submitting || !podeSalvar"
        @click="$emit('salvar')"
      >
        <v-icon>mdi-content-save-outline</v-icon>
      </v-btn>
      <v-btn
        v-if="!ultimaEtapa"
        color="primary"
        class="font-weight-bold rounded-lg flex-grow-1"
        large
        :disabled="submitting"
        @click="$emit('avancar')"
      >
        {{ tituloProxima }}
        <v-icon right>mdi-arrow-right</v-icon>
      </v-btn>
      <v-btn
        v-else
        color="primary"
        class="font-weight-bold rounded-lg flex-grow-1"
        large
        :loading="submitting"
        :disabled="submitting || !podeSalvar"
        @click="$emit('salvar')"
      >
        <v-icon left>mdi-content-save-outline</v-icon>
        Salvar
      </v-btn>
    </v-card-text>

    <v-card-text v-else class="d-flex align-center py-3 px-6">
      <v-btn
        color="grey darken-1"
        text
        large
        class="font-weight-bold rounded-lg mr-2"
        :disabled="submitting"
        @click="$emit('cancelar')"
      >
        Cancelar
      </v-btn>
      <v-btn
        outlined
        color="grey darken-1"
        large
        class="font-weight-bold rounded-lg"
        :disabled="submitting || etapaAtual === 1"
        @click="$emit('voltar')"
      >
        <v-icon left>mdi-arrow-left</v-icon>
        Voltar
      </v-btn>

      <div v-if="dica" class="d-none d-xl-flex align-center grey--text text-body-2 ml-4">
        <v-icon small class="mr-1">mdi-information-outline</v-icon>
        {{ dica }}
      </div>

      <v-spacer />

      <v-btn
        :color="ultimaEtapa ? 'primary' : 'grey darken-1'"
        :outlined="!ultimaEtapa"
        large
        class="font-weight-bold rounded-lg px-6"
        :elevation="ultimaEtapa ? 2 : 0"
        :loading="submitting"
        :disabled="submitting || !podeSalvar"
        @click="$emit('salvar')"
      >
        <v-icon left>mdi-content-save-outline</v-icon>
        Salvar Alterações
      </v-btn>

      <v-btn
        v-if="!ultimaEtapa"
        color="primary"
        large
        class="font-weight-bold rounded-lg px-6 ml-3"
        :disabled="submitting"
        @click="$emit('avancar')"
      >
        {{ tituloProxima }}
        <v-icon right>mdi-arrow-right</v-icon>
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "RhEtapaNav",
  props: {
    etapaAtual: {
      type: Number,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
    submitting: {
      type: Boolean,
      default: false,
    },
    podeSalvar: {
      type: Boolean,
      default: true,
    },
    tituloProxima: {
      type: String,
      default: "Próxima etapa",
    },
    dica: {
      type: String,
      default: "",
    },
  },
  computed: {
    ultimaEtapa() {
      return this.etapaAtual >= this.total;
    },
    mobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
};
</script>

<style scoped>
.rh-etapa-nav {
  border: 1px solid var(--border);
  position: sticky;
  bottom: 12px;
  z-index: 4;
  backdrop-filter: blur(6px);
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 8px 24px var(--shadow) !important;
}

html.tema-escuro .rh-etapa-nav {
  background: rgba(28, 26, 36, 0.92);
}
</style>
